// TODO update this to import from commmons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';

import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';

import { ListingAffirmCalloutFields } from '@reverbdotcom/commons/src/gql/graphql';
import { AffirmCallout } from './AffirmCallout';
import { isUSA } from '../../src/lib/geo';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';

type Listing = ListingAffirmCalloutFields.Fragment;

interface Props {
  listing: Listing;
}

export function ListingAffirmCallout({ listing }: Props) {
  const { estimatedMonthlyPaymentPlan, pricing, shippingPrice } = listing;
  const { buyerPrice } = pricing || {};
  const { financingProgramSlug } = estimatedMonthlyPaymentPlan || {};

  const buyerPriceDisplay = buyerPrice?.display;
  const productAmountCents = buyerPrice?.amountCents || 0;
  const shippingAmountCents = shippingPrice?.amountCents || 0;
  const totalFinancingAmountCents = productAmountCents + shippingAmountCents;

  const user = useUser();
  const emptyRender = !buyerPriceDisplay || !isUSA(user.countryCode);

  useViewTracking({
    componentName: 'ListingAffirmCallout',
    eventName: MParticleEventName.ComponentView,
    financingProgramSlug,
  }, !emptyRender);

  if (emptyRender) { return null; }

  return (
    <AffirmCallout
      amountCents={totalFinancingAmountCents}
      financingProgramSlug={financingProgramSlug}
    />
  );
}

export const ListingAffirmCalloutFragment = gql`
  fragment ListingAffirmCalloutFields on Listing {
    _id
    estimatedMonthlyPaymentPlan {
      financingProgramSlug
    },
    pricing {
      buyerPrice {
        display
        amountCents
      }
    },
    shippingPrice {
      amountCents
    }
  }
`;
